import DashboardConstants from "@/store/constants/dashboardRecords";
import DashboardInternalData from "@/internalData/Dashboard";
import CustomStyledSelect from "@/components/shared/CustomStyledSelect";
export default {
  name: "SitePatrolRecordsTable",
  components: {
    CustomStyledSelect,
  },
  data() {
    return {
      recordRates: [
        { key: "good", value: "〇" },
        { key: "bad", value: "✕" },
        { key: "notApplicable", value: "／" },
      ],
      sitePatrolRecords: DashboardInternalData.sitePatrolRecords
    };
  },
  computed: {
    sitePatrol() {
      const sitePatrol = this.$store.getters[DashboardConstants.GETTERS.getSitePatrolRecords];
      return sitePatrol;
    },
    statusEditable() {
      return this.$store.getters[DashboardConstants.GETTERS.getStatusEditable];
    },
    latestEditAs() {
      return this.$store.getters[DashboardConstants.GETTERS.getLatestEditAs];
    }
  },
  methods: {
    setSitePatrol(number, value) {
      this.$store.commit(DashboardConstants.COMMIT.setSitePatrolRecords, { number: number, value: value });
    },
    /**
     * 項目番号27と28はカスタムラベル編集可能
     * @param {number} number - 項目番号
     * @returns {boolean} - 編集可能かどうか
     */
    isCustomLabelEditable(number) {
      return number === 27 || number === 28;
    },
    /**
     * カスタムラベルを設定
     * @param {number} number - 項目番号
     * @param {string} value - カスタムラベル値
     */
    setCustomLabel(number, value) {
      this.$store.commit(DashboardConstants.COMMIT.setSitePatrolCustomLabel, { number: number, customLabel: value });
    },
    /**
     * 表示用ラベルを取得（カスタムラベルがあればそれを、なければ翻訳ラベルを返す）
     * @param {object} site - サイトパトロール項目
     * @returns {string} - 表示ラベル
     */
    getDisplayLabel(site) {
      if (this.isCustomLabelEditable(site.number) && site.customLabel != null) {
        return site.customLabel;
      }
      return this.$t("categories." + site.label);
    }
  }
};
